import {Injectable} from '@angular/core';
import {FileNameAndBase64} from "../pages/support/models/support.models";
import {AsyncSubject, Observable} from "rxjs";
import {NgxFileDropEntry} from "ngx-file-drop";
// import {async, Subject} from "rxjs";
// import {NgxFileDropEntry} from "ngx-file-drop";



@Injectable({
  providedIn: 'root'
})
export class FilesToStringService {

  // filesToStringArray$: Subject<string[]> = new Subject<string[]>()

  constructor() {
  }


  toFilesBase64(files: NgxFileDropEntry[]): Observable<FileNameAndBase64[]> {
    let selectedFiles: FileNameAndBase64[] = []
    const result = new AsyncSubject<FileNameAndBase64[]>();


    if (files?.length) {
      for (const droppedFile of files) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {

          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = (e) => {
            let base64 = reader?.result as string
            selectedFiles.push({file_name: droppedFile.relativePath, file_byte: base64.substring(base64.indexOf(',') + 1)})
            result.next(selectedFiles);
            if (files?.length === selectedFiles.length) {
              result.complete();
            }
          };
        })
      }
      return result;
    } else {
      result.next([]);
      result.complete();
      return result;
    }
  }
}
